// extracted by mini-css-extract-plugin
module.exports = {"pressRow":"styles__pressRow___3X-0l"};